import styled from 'styled-components';

import { styledMedia, styledReset } from '@pkg/primitives';

import { thumbnailOverflowWrapper } from '../../Thumbnail/tokens';

import { avatarSizePx, badgeSizePx } from './Avatar.tokens';
import { type AvatarSize } from './Avatar.types';

interface AvatarWrapperProps {
    $size: AvatarSize;
}

export const AvatarWrapper = styled.div<AvatarWrapperProps>`
    --avatar-size: ${({ $size }) => `${avatarSizePx[$size]}px`};
    --avatar-badge-size: ${({ $size }) => `${badgeSizePx[$size]}px`};

    ${styledReset.borderBox};
    position: relative;
    width: var(--avatar-size);
    height: var(--avatar-size);
`;

export const Interior = styled.div`
    ${thumbnailOverflowWrapper()};
    width: 100%;
    height: 100%;
    border-radius: 50%;
`;

///
/// Badge

export const Badge = styled.div`
    z-index: 2;
    position: absolute;
    bottom: 0.1em;
    right: 0.1em;
    display: grid;
    place-items: center;
    padding: 0.2em;
    width: var(--avatar-badge-size);
    height: var(--avatar-badge-size);
    font-size: var(--avatar-badge-size);
    background-color: ${({ theme }) => theme.colors.purple};
    border-radius: 50%;
`;

export const BadgeIconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    align-self: stretch;
    justify-self: stretch;
    color: ${({ theme }) => theme.colors.white};
`;
